import actions from 'modules/auth/authActions';

const authInitializer = store => {
  store.dispatch(actions.doInit());
};

export default authInitializer;
